if (!customElements.get('product-protection')) {
  class ProductProtection extends HTMLElement {
    constructor() {
      super();

      this.drawer = document.querySelector('cart-drawer');

      this.querySelectorAll('[data-toggle-me]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.target.closest('[data-options]').classList.toggle('is-open');
        });
      });

      this.querySelectorAll('[data-variant-size]').forEach((size) => {
        size.addEventListener('click', (event) => {
          if (event.target.closest('[data-group]').querySelector('.bg-theme-18')) {
            event.target
              .closest('[data-group]')
              .querySelector('.bg-theme-18')
              .classList.remove('bg-theme-18', 'text-white');
          }
          event.target.classList.add('bg-theme-18', 'text-white');
        });
      });

      this.querySelectorAll('[data-protection-add-to-cart]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.addToCart(event.target);
        });
      });
    }

    addToCart(item) {
      let item_id = item
        .closest('[data-product-card]')
        .querySelector('[data-group]')
        .querySelector('.bg-theme-18').dataset.variantId;

      let cart_url = `${routes.cart_add_url}`;
      let body = JSON.stringify({
        items: [
          {
            quantity: 1,
            id: parseFloat(item_id),
            sections: this.getSectionsToRender().map((section) => section.section),
            sections_url: window.location.pathname,
          },
        ],
      });

      fetch(cart_url, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((data) => {
          fetch(location.origin + '/?sections=cart-drawer,cart-icon-bubble')
            .then((response) => response.json())
            .then((data) => {
              let jsonData = data;
              jsonData.sections = data;
              this.drawer.renderContents(jsonData);
              this.drawer.open();
            });
        })
        .catch((error) => {
          document.getElementById('cart-errors').textContent = window.cartStrings.error;
        });
    }

    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        if (section?.selector) {
          const selector = document.querySelector(section.selector);
          if (selector) {
            selector.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        }
      });

      // Re-bind the close drawer buttons
      this.querySelectorAll('[data-cart-button-close]').forEach((btn) =>
        btn.addEventListener('click', this.close.bind(this))
      );

      this.applyDiscounts();
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          section: 'cart-drawer',
          selector: '[data-cart-drawer]',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '[data-cart-icon-bubble]',
        },
      ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
  }

  window.ProductProtection = ProductProtection;

  customElements.define('product-protection', ProductProtection);
}
